<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headerabbrev01" class="chapter" epub:type="frontmatter" id="abbrev">
<header id="headerabbrev01">
<h1 class="ctfm"><span aria-label=" Page x. " class="page" epub:type="pagebreak" id="px" role="doc-pagebreak"></span><span aria-label=" Page xi. " class="page" epub:type="pagebreak" id="pxi" role="doc-pagebreak"></span><a class="xref" href="#/chifoucaultcritique0006#rabbrev">Abbreviations of Works by Michel Foucault</a></h1>
</header>
<table style="border-bottom:0;">
<tbody><tr>
<td>
<p class="td"><abbr>AB</abbr> </p>
</td>
<td>
<p class="td"><i>Abnormal: Lectures at the Collège de France, 1974–1975</i>, ed. V. Marchetti and A. Salomoni, trans. Graham Burchell, English series ed. Arnold I. Davidson (New York: Picador, 2003).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>ABHS</abbr> </p>
</td>
<td>
<p class="td"><i>About the Beginning of the Hermeneutics of the Self: Lectures at Dartmouth College, 1980</i>, ed. Henri-Paul Fruchaud and Daniele Lorenzini, trans. Graham Burchell (Chicago: University of Chicago Press, 2016).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>AK</abbr> </p>
</td>
<td>
<p class="td"><i>The Archaeology of Knowledge</i>, 2nd ed., trans. A. M. Sheridan Smith (London: Routledge, 2002).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>CS</abbr> </p>
</td>
<td>
<p class="td"><i>The Care of the Self</i>, vol. 3 of <i>The History of Sexuality</i>, trans. Robert Hurley (London: Penguin, 1990).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>CT</abbr> </p>
</td>
<td>
<p class="td"><i>The Courage of Truth</i>: <i>Lectures at the Collège de France, 1983–1984</i>, ed. Frédéric Gros, trans. Graham Burchell, English series ed. Arnold I. Davidson (New York and Basingstoke: Palgrave Macmillan, 2010).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>DE I</abbr> </p>
</td>
<td>
<p class="td"><i>Dits et Écrits I, 1954–1975</i>, ed. Daniel Defert and François Ewald with the collaboration of Jacques Lagrange (Paris: Gallimard, 2001).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>DE II</abbr> </p>
</td>
<td>
<p class="td"><i>Dits et Écrits II, 1976–1988</i>, ed. Daniel Defert and François Ewald with the collaboration of Jacques Lagrange (Paris: Gallimard, 2001).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>DP</abbr> </p>
</td>
<td>
<p class="td"><i>Discipline and Punish: The Birth of the Prison</i>, trans. Alan Sheridan (London: Penguin, 1991).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span aria-label=" Page xii. " class="page" epub:type="pagebreak" id="pxii" role="doc-pagebreak"></span><abbr>EW 1</abbr> </p>
</td>
<td>
<p class="td"><i>The Essential Works of Foucault, 1954–1984</i>, vol. 1, <i>Ethics: Subjectivity and Truth</i>, ed. Paul Rabinow (New York: New Press, 1997).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>EW 2</abbr> </p>
</td>
<td>
<p class="td"><i>The Essential Works of Foucault, 1954–1984</i>, vol. 2, <i>Aesthetics, Method, and Epistemology</i>, ed. James D. Faubion (New York: New Press, 1998).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>EW 3</abbr> </p>
</td>
<td>
<p class="td"><i>The Essential Works of Foucault, 1954–1984</i>, vol. 3, <i>Power</i>, ed. James D. Faubion (New York: New Press, 2000).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>FL</abbr> </p>
</td>
<td>
<p class="td"><i>Foucault Live: Collected Interviews, 1961–1984</i>, ed. Sylvère Lotringer, trans. Lysa Hochroth and John Johnston (New York: Semiotext(e), 1996).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>GL</abbr> </p>
</td>
<td>
<p class="td"><i>On the Government of the Living: Lectures at the Collège de France, 1979–1980</i>, ed. Michel Senellart, trans. Graham Burchell, English series ed. Arnold I. Davidson (New York and Basingstoke: Palgrave Macmillan, 2014).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>GSO</abbr> </p>
</td>
<td>
<p class="td"><i>The Government of Self and Others: Lectures at the Collège de France, 1982–1983</i>, ed. Frédéric Gros, trans. Graham Burchell, English series ed. Arnold I. Davidson (New York and Basingstoke: Palgrave Macmillan, 2010).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>HIST</abbr> </p>
</td>
<td>
<p class="td"><i>The History of Sexuality</i>, vol. 1, <i>An Introduction</i>, trans. Robert Hurley (New York: Random House, 1978).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>HS</abbr> </p>
</td>
<td>
<p class="td"><i>The Hermeneutics of the Subject: Lectures at the Collège de France, 1981–1982</i>, ed. Frédéric Gros, trans. Graham Burchell, English series ed. Arnold I. Davidson (New York and Basingstoke: Palgrave Macmillan, 2005).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>PP</abbr> </p>
</td>
<td>
<p class="td"><i>Psychiatric Power: Lectures at the Collège de France, 1973–1974</i>, ed. Jacques Lagrange, trans. Graham Burchell, English series ed. Arnold I. Davidson (New York and Basingstoke: Palgrave Macmillan, 2010).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>ST</abbr> </p>
</td>
<td>
<p class="td"><i>Subjectivity and Truth: Lectures at the Collège de France, 1980–1981</i>. ed. Frédéric Gros, trans. Graham Burchell, English series ed. Arnold I. Davidson (New York and Basingstoke: Palgrave Macmillan, 2017).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>STP</abbr> </p>
</td>
<td>
<p class="td"><i>Security, Territory, Population: Lectures at the Collège de France, 1977–1978</i>, ed. Michel Senellart, trans. Graham Burchell, <span aria-label=" Page xiii. " class="page" epub:type="pagebreak" id="pxiii" role="doc-pagebreak"></span>English series ed. Arnold I. Davidson (New York and Basingstoke: Palgrave Macmillan, 2007).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>UP</abbr> </p>
</td>
<td>
<p class="td"><i>The Use of Pleasure</i>, vol. 2 of <i>The History of Sexuality</i>, trans. Robert Hurley (London: Penguin, 1985).</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>WDTT</abbr> </p>
</td>
<td>
<p class="td"><i>Wrong-Doing, Truth-Telling: The Function of Avowal in Justice</i>, ed. Fabienne Brion and Bernard E. Harcourt, trans. Stephen W. Sawyer (Chicago: University of Chicago Press, 2014).</p>
</td>
</tr>
</tbody></table>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-foucault-critique-0009.vue?2c5e47c1